/**
 * Shared document-type rules used by both the ID-type selection screen
 * (SmartComplyFlow) and the capture component (DocumentCapture) — kept in
 * one place so the two can't silently diverge on which documents need a
 * back-side photo.
 */

/**
 * Whether a document's back side should be captured:
 *   true      — required, the flow forces a back-capture step
 *   false     — never offered
 *   "optional" — offered, but the user can skip it and proceed on front alone
 */
export type BackSideMode = boolean | "optional";

/** Documents where the backend OCR pipeline needs (or can use) the reverse side. */
export function requiresBackSide(documentType: string): BackSideMode {
  const type = documentType.toLowerCase();
  if (type.includes("nin")) {
    // The physical NIN card is two-sided, but not every printed card in
    // circulation carries meaningful back-side content — offer the step
    // instead of forcing it.
    return "optional";
  }
  return type.includes("voter") ||
         type.includes("driver") ||
         type.includes("license") ||
         type.includes("national id") ||
         type.includes("national id card") ||
         type.includes("ghana");
  // Passport: back side is the machine-readable zone but OCR reads from front only.
}

/**
 * Scale ratio for fitting an image within maxWidth x maxHeight, never
 * upscaling. Used by DocumentCapture's canvas sizing.
 */
export function computeScaleRatio(
  srcWidth: number,
  srcHeight: number,
  maxWidth: number,
  maxHeight: number
): number {
  return Math.min(maxWidth / srcWidth, maxHeight / srcHeight, 1);
}
